import { render, staticRenderFns } from "./PopoverRepairReasonForm.vue?vue&type=template&id=563437c2"
import script from "./PopoverRepairReasonForm.vue?vue&type=script&lang=js"
export * from "./PopoverRepairReasonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports